export default __webpack_public_path__ + "static/media/move_icon.de0c46bd.png";